module.exports = __webpack_public_path__ + "img/bg.ba7e6e54.png";